/**
 * Component responsible to add notification functionality using the notifcation component from garden.
 */
import $ from 'jquery'

import Notification from 'garden/src/js/components/notification'

export default ($el) => $el.notification({ dynamic: false })
